import changelog from "../../CHANGELOG.md?raw";
import { formatAppVersion } from "../config/app-version";
import { parseReleaseNotes } from "../config/release-notes";

const RECENT_RELEASES = 5;

/** What this build is, and what changed lately, from CHANGELOG.md. */
export function StatusReleases() {
  const running = formatAppVersion(
    import.meta.env.VITE_APP_VERSION,
    import.meta.env.VITE_RELEASE_STAGE,
  );
  const releases = parseReleaseNotes(changelog).slice(0, RECENT_RELEASES);
  return (
    <section className="status-releases" aria-labelledby="status-releases-title">
      <h2 id="status-releases-title" className="status-releases__title">
        Releases
      </h2>
      <p className="status-releases__running">
        This build: <strong>{running ?? "unknown"}</strong>
      </p>
      {releases.map((release) => (
        <article key={release.version ?? "unreleased"} className="status-releases__release">
          <h3 className="status-releases__version">
            {release.version === null ? "Not released yet" : `v${release.version}`}
            {release.date === null ? null : (
              <span className="status-releases__date"> · {release.date}</span>
            )}
          </h3>
          {release.groups.map((group) => (
            <div key={group.heading}>
              {group.heading === "" ? null : (
                <h4 className="status-releases__group">{group.heading}</h4>
              )}
              <ul className="status-releases__items">
                {group.items.map((item) => <li key={item}>{item}</li>)}
              </ul>
            </div>
          ))}
        </article>
      ))}
    </section>
  );
}
